// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W24M","type":"styles_type__2vpen","choices":"styles_choices__3DEbj"};